import { Button } from '@form-factory/chatbot-ui';

interface StepCounterProps {
  totalSteps: number;
  currentStep: number;
  onStepClick: (step: number) => void;
}

function StepCounter({
  totalSteps,
  currentStep,
  onStepClick,
}: StepCounterProps) {
  return (
    <div className='flex h-10 items-center justify-center gap-2'>
      {Array.from({ length: totalSteps + 1 }, (_, index) => (
        <Button
          key={index + 1}
          variant={index <= currentStep ? 'primary' : 'outline'}
          onClick={() => index < currentStep && onStepClick(index)} // Only call if step is completed
        >
          {index + 1}
        </Button>
      ))}
    </div>
  );
}

export default StepCounter;
